import { DiscoveredRelease } from '../../services/releases';

export const DEV_IOS_MONOTONIC_BUILD_START = 101;

export function preferredReleaseNote(release?: DiscoveredRelease | null): string {
  const notes = release?.releaseNotes || [];
  return notes.find((note) => note.locale.toLowerCase() === 'en-us')?.text
    || notes.find((note) => note.locale.toLowerCase().startsWith('en'))?.text
    || notes[0]?.text
    || '';
}

export function cutoffReleases(
  releases: DiscoveredRelease[],
  latestBuild: number,
): DiscoveredRelease[] {
  const uniqueBuilds = new Map<number, DiscoveredRelease>();
  releases
    .filter((release) => release.build > 0 && release.build <= latestBuild)
    .forEach((release) => {
      if (!uniqueBuilds.has(release.build)) uniqueBuilds.set(release.build, release);
    });
  return Array.from(uniqueBuilds.values()).sort((a, b) => b.build - a.build);
}

export function supportsForcedUpdates(
  environment: 'dev' | 'prod',
  platform: 'android' | 'ios',
  build: number,
): boolean {
  return environment !== 'dev'
    || platform !== 'ios'
    || build >= DEV_IOS_MONOTONIC_BUILD_START;
}
